import { useState } from "react";
import { FiMapPin, FiChevronDown, FiChevronUp } from "react-icons/fi";
import styles from "./PinBar.module.css";

const PinBar = ({ pinnedMessages, onJump }) => {
  const [expanded, setExpanded] = useState(false);
  if (!pinnedMessages?.length) return null;

  const latest = pinnedMessages[pinnedMessages.length - 1];

  const getPinLabel = (msg) => {
    if (msg.isVoice || msg.voiceUrl)    return "Voice message";
    if (msg.gifUrl)                      return "GIF";
    if (msg.image && !msg.text)          return "Photo";
    if (msg.file && msg.fileType?.startsWith("video")) return "Video";
    if (msg.file && msg.fileType?.startsWith("image")) return "Photo";
    if (msg.file)                        return msg.fileName || "File";
    if (msg.text)                        return msg.text.slice(0, 60) + (msg.text.length > 60 ? "…" : "");
    return "Message";
  };

  return (
    <div className={styles.bar}>
      <FiMapPin size={13} className={styles.icon} />
      {!expanded ? (
        <div className={styles.single} onClick={() => onJump(latest._id)}>
          <span className={styles.label}>Pinned:</span>
          <span className={styles.text}>{getPinLabel(latest)}</span>
        </div>
      ) : (
        <div className={styles.list}>
          {pinnedMessages.slice().reverse().map((msg, i) => (
            <div key={msg._id} className={styles.listItem} onClick={() => { onJump(msg._id); setExpanded(false); }}>
              <span className={styles.listNum}>{pinnedMessages.length - i}</span>
              <span className={styles.listText}>{getPinLabel(msg)}</span>
            </div>
          ))}
        </div>
      )}
      {pinnedMessages.length > 1 && (
        <button className={styles.toggle} onClick={() => setExpanded((p) => !p)} title={expanded ? "Collapse" : "Show all pins"}>
          {expanded ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
        </button>
      )}
    </div>
  );
};

export default PinBar;
